import { Button, Flex, FormLabel, IconButton, Input, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Stack, Textarea, useToast } from "@chakra-ui/react";

import { GrClose } from "react-icons/gr";
import { HiArrowLeft, HiArrowRight } from "react-icons/hi";
import { useSelector } from "react-redux";
import APIDropdown from "../../components/Select/APIDropdown";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import {ChangeEvent,  useEffect, useState } from 'react';
import { GET, GETFile, PUT } from "../../utils/ApiRequestProvider";
import SearchInput from "../../components/Inputs/SearchInput";

export interface EditModalProps {
    isOpen: boolean;
    onClose: () => void;
    documents: Array<any>;
    selectedDocument: any;
    Refresh?: () => void;
}

interface FileViewerType {
    uri: string;
    fileName: string;
}

interface FormFields {
    id:number,
    contactId?: number,
    documentType?: string,
    invoiceDate?: string,
    dueDate?: string,
    invoiceNumber?: string,
    categoryId: number,
    vatGstRateValue: number;
    vatGstRateId: number,
    paymentMethodId: number,
    grossAmount: string,
    vatAmount: string,
    netAmount: number,
    exchangeRate: number,
    convertedGrossAmount: number,
    convertedVATAmount: number,
    convertedNetAmount: number,
    description?: string,
    processingNotes?: string,
    multipleDocuments?: boolean,
    isDeleted?: boolean,
    status?: string,
    transactionCurrencyId?: number,
    BaseCurrency?: string,
    isSave: boolean,
}

const initialFormData: FormFields = {
    id: 0,
    vatGstRateId: 0,
    vatGstRateValue: 0,
    grossAmount: '0.00',
    vatAmount:  '0.00',
    netAmount: 0,
    exchangeRate: 0,
    paymentMethodId: 0,
    convertedGrossAmount: 0,
    convertedVATAmount: 0,
    convertedNetAmount: 0,
    BaseCurrency: 'AUD',
    isSave: false,
    categoryId: 0
}

export default function EditModal({ isOpen, onClose, documents, selectedDocument, Refresh }: EditModalProps) {
    const toast = useToast();
    const business = useSelector((state: any) => state.selections.value?.business);

    const [currentDocument, setCurrentDocument] = useState<any>({});
    const [selectedDocs, setSelectedDocs] = useState<FileViewerType[]>([]);
    const [contacts, setContacts] = useState<Array<any>>([]);
    const [form, setForm] = useState<FormFields>(initialFormData);
    const [isLoading, setLoading] = useState<boolean>(false);
    
    useEffect(() => {
        // setSelectedDocs(currentDocument);
        if (selectedDocument !== null){
            if(selectedDocument.status === "Processed"){
                setCurrentDocument(selectedDocument);
            }else{
                setCurrentDocument([]);
            }
            ViewDocument(selectedDocument.file);
            // const encodedUrl: string = encodeURI(url);
            
        }
        
        initModal(selectedDocument);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedDocument]);

    async function ViewDocument(name: string) {
        const file = await GETFile(name);

        setSelectedDocs([
            {uri: URL.createObjectURL(file),
            fileName : name}
        ]);
    }

    const handleInputChange = (
        eventOrValue: ChangeEvent<any> | string,
        fieldName?: string
    ) => {
        // console.log(eventOrValue);
                // debugger;
        // console.log(eventOrValue);
        setForm((prevForm) => {
            if (!prevForm) {
                return prevForm;
            }
            const name = fieldName ? fieldName : (typeof eventOrValue === 'object' ? eventOrValue.target?.name : fieldName);
            const value = typeof eventOrValue === 'object' ? eventOrValue.target?.value : eventOrValue;
            if (!name) {
                return prevForm;
            }
            return {
                ...prevForm,
                [name]: value,
            };
        });
        // calculate(val,fieldName);
    };

    useEffect(() => {
        (async () => {
            if (business?.id) {
                const res = await GET(`/api/contacts/${business?.id}?isSupplier=true`);
                if (res.status === "error"){
                    toast({
                        status: "error",
                        title: "Something Went Wrong!",
                        description: "An unexpected error ocurred while proceeding your request!",
                        duration: 5000,
                        position: 'top-right'
                    });

                    setTimeout(() => window.location.reload(), 5000);
                }

                setContacts(res.data);
            }
        })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [business]);

    const vatGstRateChange = (e: any) => {
        console.log(e);
        if(e !== undefined){
            calculate(e.percentage,'vatGstRateId',e.id);
        }else{
            calculate('0.00','vatGstRateId',0);
        }
        // setFormData(prev => ({ ...prev, vatGstRateId: e.id, vatGstRateValue: e.percentage }));
    }

    const calculate = async (val: string,field?: string,id: number = 0) => {
        const updatedFormData = { ...form };
        let gstRate = 0;

        if(field === 'vatGstRateId'){
            gstRate = parseFloat((parseFloat(val) / 100).toFixed(2));
            updatedFormData.vatGstRateValue = parseFloat(val);
            updatedFormData.vatGstRateId = id;
        }else{
            gstRate = parseFloat((updatedFormData.vatGstRateValue / 100).toFixed(2)) ;
        }
        // debugger;
        if(field === 'grossAmount'){
            updatedFormData.grossAmount = val;
        }
        if(field === 'exchangeRate'){
            updatedFormData.exchangeRate = parseFloat(val);
        }
        let netAmount = parseFloat((parseFloat(updatedFormData.grossAmount) / (1 + gstRate)).toFixed(2));
        let vatAmount = parseFloat((netAmount * gstRate).toFixed(2));
        // updatedFormData.grossAmount = formData.grossAmount;
        updatedFormData.vatAmount = (vatAmount).toString();
        updatedFormData.netAmount = netAmount;
        updatedFormData.convertedGrossAmount = parseFloat((parseFloat(updatedFormData.grossAmount) * updatedFormData.exchangeRate).toFixed(2));
        updatedFormData.convertedNetAmount = parseFloat((netAmount * updatedFormData.exchangeRate).toFixed(2));
        updatedFormData.convertedVATAmount = parseFloat((updatedFormData.exchangeRate * vatAmount).toFixed(2));
        setForm(updatedFormData);
        // console.log(updatedFormData);
    };

    useEffect(() => {
        initModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentDocument]);

    function initModal(doc: any = currentDocument) {
        if (doc?.file) {
            if(doc.status === "Data Entered"){
                // console.log(doc);

                const data = {
                    id: doc?.id,
                    categoryId: doc?.category?.id,
                    contactId: doc?.contact?.id,
                    documentType: doc?.documentType,
                    invoiceDate: doc?.invoiceDate.split("T")[0],
                    dueDate: doc?.dueDate.split("T")[0],
                    invoiceNumber: doc?.invoiceNumber,
                    vatGstRateValue: doc?.vatgstRate?.percentage,
                    vatGstRateId: doc?.vatgstRate?.id,
                    paymentMethodId: doc?.paymentMethod?.id,
                    grossAmount: doc?.grossAmount,
                    vatAmount: doc?.vatAmount,
                    netAmount: doc?.netAmount,
                    exchangeRate: doc?.exchangeRate,
                    convertedGrossAmount: doc?.convertedGrossAmount,
                    convertedVATAmount: doc?.convertedVATAmount,
                    convertedNetAmount: doc?.convertedNetAmount,
                    description: doc?.description,
                    processingNotes: doc?.processingNotes,
                    multipleDocuments: doc?.multipleDocuments,
                    isDeleted: doc?.isDeleted,
                    status: doc?.status,
                    transactionCurrencyId: doc?.transactionCurrency?.id,
                    BaseCurrency: doc?.transactionCurrency?.currencyCode,
                    isSave: false,
                };
                setForm(data);
            }
        }
    }

    function onNextDocument() {
        let curIdx = documents.findIndex(x => x.id === currentDocument.id);
        setCurrentDocument(documents[curIdx >= (documents.length - 1) ? 0 : curIdx + 1]);
    }

    function onPrevDocument() {
        let curIdx = documents.findIndex(x => x.id === currentDocument.id);
        setCurrentDocument(documents[curIdx <= 0 ? documents.length - 1 : curIdx - 1]);
    }

    const handleBaseCurrencyChange = async (e: any) => {
        const transactionCurrency = e.currencyCode;
        const BaseCurrency = business?.baseCurrency?.currencyCode;
        const response = await GET(`https://api.freecurrencyapi.com/v1/latest?apikey=fca_live_FSQ5KPY2ukwYeHDJ4YUItGho4OKosDa38YUp94bR&currencies=${transactionCurrency}&base_currency=${BaseCurrency}`);
        if(response.data !== null && response.data !== undefined){
            const exchangeRate = response.data[transactionCurrency];
            const updatedFormData = { ...form };
            updatedFormData.transactionCurrencyId = e.id;
            updatedFormData.exchangeRate = parseFloat(exchangeRate.toFixed(4));
            updatedFormData.convertedGrossAmount = parseFloat((parseFloat(form.grossAmount) * exchangeRate).toFixed(2));
            updatedFormData.convertedVATAmount = parseFloat((parseFloat(form.vatAmount) * exchangeRate).toFixed(2));
            updatedFormData.convertedNetAmount = parseFloat(((form.netAmount) * exchangeRate).toFixed(2));
            setForm(updatedFormData);
        }
        else{
            toast({
                title: 'Error!',
                description: 'Could not fetch exchange rate for the selected currency.',
                status: 'error',
                isClosable: true,
                duration: 1000,
                position: 'top-right'
            });
        }
    }

    async function Save() {
        try {
            setLoading(true);

            const response = await PUT(
                `/api/Documents/approve/${form.id}`,
                form
            );

            toast({
                status: 'success',
                title: 'Approved',
                description: 'Document has been approved successfully.',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });

            setLoading(false);

            if (response.status === 'success') {
                setTimeout(() => {
                    window.location.reload();
                },2000);
            }
        } catch (err) {
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occured while proceeding your request!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
        }
    }

    const handleRedo = async () => {
        const response = await PUT(`api/Documents/reAssign/${form.id}?status=Review`, {});
        if(response.status === 'success'){
            toast({
                title: 'Reassigned!',
                description: 'Document has been Reassigned successfully!',
                status: 'success',
                isClosable: true,
                duration: 1000,
                position: 'top-right'
            });
            onClose();
        }
    }

    return (
        <Modal
            isCentered
            size={'full'}
            isOpen={isOpen}
            onClose={onClose}
        >
            <ModalOverlay
                bg='blackAlpha.300'
                backdropFilter='blur(10px)'
            />
            <ModalContent>
                <ModalHeader
                    borderBottom={'2px'}
                    borderBottomColor={'gray.300'}
                >
                    <Stack
                        spacing={4}
                        direction={'row'}
                        justify={'space-between'}
                        align={'center'}
                    >
                        <Flex gap={2}>
                            <Stack spacing={0} justify={'center'}>
                                <FormLabel fontSize={'8px'}>Document ID</FormLabel>
                                <Input
                                    type={'text'}
                                    value={currentDocument?.invoiceNumber}
                                    readOnly
                                    w={'100px'}
                                    size={'sm'}
                                />
                            </Stack>
                            <Stack spacing={0} justify={'center'}>
                                <FormLabel fontSize={'8px'}>Document Type</FormLabel>
                                <Select
                                    size={'sm'}
                                    w={'xs'}
                                    value={form?.documentType}
                                    name="documentType"
                                    onChange={handleInputChange}
                                >
                                    <option value="Invoices">Invoices</option>
                                    <option value="Invoices & Receipts">Invoices & Receipts</option>
                                    <option value="Receipt">Receipt</option>
                                    <option value="Credit Note (Refund)">Credit Note (Refund)</option>
                                    <option value="Processing Error">Processing Error</option>
                                    <option value="Duplicate Type">Duplicate Type</option>
                                </Select>
                            </Stack>
                        </Flex>
                        <Flex gap={4}>
                            <IconButton
                                rounded={'full'}
                                aria-label='Previous Document'
                                size='lg'
                                onClick={onPrevDocument}
                                icon={<HiArrowLeft />}
                            />
                            <IconButton
                                aria-label='Next Document'
                                size='lg'
                                onClick={onNextDocument}
                                rounded={'full'}
                                icon={<HiArrowRight />}
                            />
                            <IconButton
                                colorScheme={'whiteAlpha'}
                                aria-label='Close Modal'
                                size='lg'
                                rounded={'full'}
                                icon={<GrClose />}
                                onClick={onClose}
                            />
                        </Flex>
                    </Stack>
                </ModalHeader>
                <ModalBody>
                    <Stack
                        w={'full'}
                        direction={'row'}
                        justify={'space-between'}
                        spacing={8}
                        py={4}
                    >
                        <Stack
                            w={'60%'}
                            spacing={2}
                        >
                            <Stack
                                direction={'row'}
                            >
                                <Stack w={'70%'} spacing={0} justify={'center'}>
                                    <FormLabel fontSize={'8px'}>Contact Name</FormLabel>
                                    <SearchInput
                                        options={contacts.map(c => ({ label: c.name, value: c.id }))}
                                        size={'sm'}
                                        onChange={e => setForm({ ...form, contactId: e.value })}
                                        value={form.contactId}
                                    />
                                </Stack>
                                <Stack w={'30%'} spacing={0} justify={'center'}>
                                    <FormLabel fontSize={'8px'}>Document Number</FormLabel>
                                    <Input
                                        type={'text'}
                                        value={form?.invoiceNumber}
                                        w={'full'}
                                        size={'sm'}
                                        disabled
                                    />
                                </Stack>
                            </Stack>
                            <Stack
                                direction={'row'}
                            >
                                <Stack w={'full'} spacing={0} justify={'center'}>
                                    <FormLabel fontSize={'8px'}>Document Date</FormLabel>
                                    <Input
                                        type={'date'}
                                        value={form?.invoiceDate?.split("T")[0]}
                                        name="invoiceDate"
                                        onChange={handleInputChange}
                                        w={'full'}
                                        size={'sm'}
                                    />
                                </Stack>
                                <Stack w={'full'} spacing={0} justify={'center'}>
                                    <FormLabel fontSize={'8px'}>Due / Payment Date</FormLabel>
                                    <Input
                                        type={'date'}
                                        value={form?.dueDate?.split("T")[0]}
                                        name="dueDate"
                                        onChange={handleInputChange}
                                        w={'full'}
                                        size={'sm'}
                                    />
                                </Stack>
                                
                                <Stack w={'full'} spacing={0} justify={'center'}>
                                    <FormLabel fontSize={'8px'}>Transaction Currency</FormLabel>
                                    <APIDropdown
                                        w={'full'}
                                        placeholder={'Transaction Currency'}
                                        fetchurl={'/api/currency'}
                                        itemselect={handleBaseCurrencyChange}
                                        valuekey={'id'}
                                        textkey={'currencyName'}
                                        // selectedvalue={form?.transactionCurrencyId}
                                        value={form?.transactionCurrencyId}
                                        size={'sm'}
                                    />
                                </Stack>
                                {
                                    (
                                        form?.transactionCurrencyId !== business?.baseCurrency?.id &&
                                        form?.transactionCurrencyId !== undefined
                                    ) && (
                                        <Stack w={'full'} spacing={0} justify={'center'}>
                                            <FormLabel fontSize={'8px'}>Exchange Rate</FormLabel>
                                            <Input
                                                type={'number'}
                                                value={form?.exchangeRate}
                                                onChange={(e)=> calculate(e.target.value,'exchangeRate')}
                                                w={'full'}
                                                size={'sm'}
                                            />
                                        </Stack>
                                    )
                                }
                            </Stack>
                            <Stack
                                direction={'row'}
                            >
                                <Stack w={'40%'} spacing={0} justify={'center'}>
                                    <FormLabel fontSize={'8px'}>Category</FormLabel>
                                    <APIDropdown
                                        w={'full'}
                                        placeholder={'Category'}
                                        fetchurl={`/api/chartofaccounts/${business?.id}`}
                                        itemselect={handleInputChange}
                                        valuekey={'id'}
                                        textkey={'category'}
                                        size={'sm'}
                                        // selectedvalue={form?.categoryId}
                                        value={form?.categoryId}
                                    />
                                </Stack>
                                <Stack w={'30%'} spacing={0} justify={'center'}>
                                    <FormLabel fontSize={'8px'}>Gross Amount</FormLabel>
                                    <Input
                                        type={'number'}
                                        value={form?.grossAmount}
                                        name="grossAmount"
                                        onChange={(e)=> calculate(e.target.value,'grossAmount')}
                                        w={'full'}
                                        size={'sm'}
                                    />
                                </Stack>
                                <Stack w={'30%'} spacing={0} justify={'center'}>
                                    <FormLabel fontSize={'8px'}>Net Amount</FormLabel>
                                    <Input
                                        type={'number'}
                                        value={form?.netAmount}
                                        name="netAmount"
                                        w={'full'}
                                        size={'sm'}
                                        readOnly
                                    />
                                </Stack>
                                {
                                    (
                                        form?.transactionCurrencyId !== business?.baseCurrency?.id &&
                                        form?.transactionCurrencyId !== undefined
                                    ) && (
                                        <Stack w={'30%'} spacing={0} justify={'center'}>
                                            <FormLabel fontSize={'8px'}>Converted Net Amount</FormLabel>
                                            <Input
                                                type={'number'}
                                                name="convertedNetAmount"
                                                value={form?.convertedNetAmount}
                                                w={'full'}
                                                size={'sm'}
                                                readOnly
                                            />
                                        </Stack>
                                    )
                                }
                            </Stack>
                            <Stack
                                direction={'row'}
                            >
                                <Stack w={'full'} spacing={0} justify={'center'}>
                                    <FormLabel fontSize={'8px'}>Payment Method</FormLabel>
                                    <APIDropdown
                                        w={'full'}
                                        placeholder={'Payment Method'}
                                        fetchurl={`/api/paymentmethods/${business?.id}`}
                                        itemselect={handleInputChange}
                                        valuekey={'id'}
                                        textkey={'displayName'}
                                        size={'sm'}
                                        // selectedvalue={form?.paymentMethodId}
                                        value={form?.paymentMethodId}
                                    />
                                </Stack>
                                <Stack w={'full'} spacing={0} justify={'center'}>
                                    <FormLabel fontSize={'8px'}>VAT / GST Rate</FormLabel>
                                    <APIDropdown
                                        w={'full'}
                                        placeholder={'VAT / GST Rate'}
                                        fetchurl={`/api/vatgst/${business?.id}`}
                                        itemselect={vatGstRateChange}
                                        valuekey={'id'}
                                        textkey={'name'}
                                        size={'sm'}
                                        value={form?.vatGstRateId}
                                    />
                                </Stack>
                                <Stack w={'full'} spacing={0} justify={'center'}>
                                    <FormLabel fontSize={'8px'}>VAT / GST Amount</FormLabel>
                                    <Input
                                        type={'number'}
                                        value={form?.vatAmount}
                                        w={'full'}
                                        size={'sm'}
                                        readOnly
                                    />
                                </Stack>
                                {
                                    (
                                        form?.transactionCurrencyId !== business?.baseCurrency?.id &&
                                        form?.transactionCurrencyId !== undefined
                                    ) && (
                                        <Stack w={'full'} spacing={0} justify={'center'}>
                                            <FormLabel fontSize={'8px'}>Converted VAT / GST Amount</FormLabel>
                                            <Input
                                                type={'number'}
                                                value={form?.convertedVATAmount}
                                                w={'full'}
                                                size={'sm'}
                                                disabled
                                            />
                                        </Stack>
                                    )
                                }
                            </Stack>
                            <Stack
                                direction={'row'}
                                align={'start'}
                            >
                                <Stack w={'70%'} spacing={0} justify={'center'}>
                                    <FormLabel fontSize={'8px'}>Description</FormLabel>
                                    <Textarea
                                        resize={'none'}
                                        h={'50px'}
                                        rounded={'none'}
                                        placeholder={'Description goes here'}
                                        value={form?.description}
                                        onChange={handleInputChange}
                                    />
                                </Stack>
                                {
                                    (
                                        form?.transactionCurrencyId !== business?.baseCurrency?.id &&
                                        form?.transactionCurrencyId !== undefined
                                    ) && (
                                        <Stack w={'30%'} spacing={0} justify={'center'}>
                                            <FormLabel fontSize={'8px'}>Converted Gross Amount</FormLabel>
                                            <Input
                                                type={'number'}
                                                value={form?.convertedGrossAmount}
                                                w={'full'}
                                                size={'sm'}
                                                readOnly
                                            />
                                        </Stack>
                                    )
                                }
                            </Stack>
                            <Stack
                                pt={12}
                                direction={'row'}
                                align={'start'}
                            >
                                <Stack w={'full'} spacing={0} justify={'center'}>
                                    <FormLabel fontSize={'8px'}>File Name</FormLabel>
                                    <Input
                                        type={'text'}
                                        value={currentDocument?.file?.split("/")[currentDocument?.file?.split("/")?.length - 1]}
                                        w={'full'}
                                        size={'sm'}
                                        disabled
                                    />
                                </Stack>
                                <Stack w={'full'} spacing={0} justify={'center'}>
                                    <FormLabel fontSize={'8px'}>Uploaded By</FormLabel>
                                    <Input
                                        type={'text'}
                                        value={currentDocument?.user?.fullName}
                                        w={'full'}
                                        size={'sm'}
                                        disabled
                                    />
                                </Stack>
                                <Stack w={'full'} spacing={0} justify={'center'}>
                                    <FormLabel fontSize={'8px'}>Upload Date</FormLabel>
                                    <Input
                                        type={'text'}
                                        value={new Date(currentDocument?.createdAt).toLocaleDateString()}
                                        w={'full'}
                                        size={'sm'}
                                        disabled
                                    />
                                </Stack>
                            </Stack>
                            <Stack display={'inline'} justifyContent={'space-between'}
                            >
                                    <Button w={'xs'} m={'2'} onClick={onClose} >
                                        Close
                                    </Button>
                                    <Button w={'xs'} m={'2 !important'} onClick={() => Save()}
                                        colorScheme={'primary'} isLoading={isLoading} >
                                        Approve
                                    </Button>
                                    <Button w={'xs'} m={'2 !important'} onClick={() => handleRedo()}
                                        backgroundColor={'red'} color={'white'} _hover={{ bg: 'blue' }} >
                                        Reassign
                                    </Button>
                            </Stack>
                        </Stack>
                        <Stack w={'40%'} h={'100vh'} overflow={'scroll'}>
                            <DocViewer
                                documents={selectedDocs}
                                pluginRenderers={DocViewerRenderers}
                            />
                        </Stack>
                    </Stack>
                </ModalBody>
                <ModalFooter
                    as={Stack}
                    direction={'row'}
                    spacing={4}
                    borderTop={'2px'}
                    borderTopColor={'gray.300'}
                >
                    
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}